import QmExample from './src/main'

/* istanbul ignore next */
QmExample.install = function (Vue) {
  Vue.component(QmExample.name, QmExample)
}

export default QmExample
